import React from 'react';
import { ModalProvider } from '../../../../context/ModalContext';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import { Modal } from '../../../../components/Modals/Modal';
import ShareJobModal from '../../../../components/Modals/ModalsActions/ShareJobModal';
import styled from '@emotion/styled';
import { OutlineShare } from '../../../../components/Icons/OutlineShare';

const ShareJob = () => {
  return (
    <ModalProvider>
      <ModalTriggerContainer>
        <IconWrapper>
          <OutlineShare />
        </IconWrapper>
      </ModalTriggerContainer>
      <Modal>
        <ShareJobModal />
      </Modal>
    </ModalProvider>
  );
};

export default ShareJob;

const IconWrapper = styled.div`
  cursor: pointer;
  min-width: 24px;
  min-height: 24px;
  color: ${({ theme }) => theme.palette.greyGrey2};
`;

// this component is ahred with InvitedJobsInfo as well